import './Headline.css';

import React from 'react';

import type { AnimationType, ContentText, TextSize } from '../../global-types/Content';

type HeadlineProps = {
  text: string;
  size?: TextSize;
  child?: ContentText;
  animation?: AnimationType;
};

const Headline = React.forwardRef<HTMLHeadingElement, HeadlineProps>(({ text, size, child, animation }, ref) => {
  let textSize: string;
  switch (size) {
    case 'xx-small':
      textSize = 'xx-small';
      break;
    case 'x-small':
      textSize = 'x-small';
      break;
    case 'small':
      textSize = 'small';
      break;
    case 'medium':
      textSize = 'medium';
      break;
    case 'large':
      textSize = 'large';
      break;
    case 'x-large':
      textSize = 'x-large';
      break;
    default:
      textSize = 'medium';
      break;
  }

  const validAnimations: AnimationType[] = ['adding', 'notifying'];
  const animationClass = animation && validAnimations.includes(animation) ? animation : '';

  return (
    <h3 ref={ref} className={`if typography heading ${textSize} ${animationClass}`}>
      {text}
      {child && <span className={`if tag green ${child.animation}`}>{child.value}</span>}
    </h3>
  );
});

export default Headline;
